interface createUrlUtilityProps {
  baseUrl?: string;
  params: string;
}

function createUrlUtility({
  baseUrl = process.env.CDN_BASE_URL ?? 'https://cdn.witro.shop',
  params,
}: createUrlUtilityProps) {
  // Ensure baseUrl is a non-empty string; otherwise, use the default
  const resolvedBaseUrl =
    typeof baseUrl === 'string' && baseUrl.trim() !== ''
      ? baseUrl
      : process.env.CDN_BASE_URL || 'https://cdn.witro.shop';

  return `${resolvedBaseUrl}/${params}`;
}

export default createUrlUtility;
